import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

const LABELS = { view: "VIEW", drag: "DRAG", link: "→" };

export default function CustomCursor() {
  const [enabled, setEnabled] = useState(false);
  const [variant, setVariant] = useState("default");
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 550, damping: 45, mass: 0.5 });
  const sy = useSpring(y, { stiffness: 550, damping: 45, mass: 0.5 });

  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;
    setEnabled(true);
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const over = (e) => {
      const t = e.target.closest("[data-cursor]");
      setVariant(t ? t.dataset.cursor : "default");
    };
    window.addEventListener("mousemove", move, { passive: true });
    document.addEventListener("mouseover", over, { passive: true });
    return () => {
      window.removeEventListener("mousemove", move);
      document.removeEventListener("mouseover", over);
    };
  }, [x, y]);

  if (!enabled) return null;

  return (
    <motion.div
      data-testid="custom-cursor"
      className="fixed top-0 left-0 z-[200] pointer-events-none"
      style={{ x: sx, y: sy }}
    >
      <motion.div
        animate={variant}
        variants={{
          default: { width: 10, height: 10, backgroundColor: "#F4EFE7" },
          link: { width: 52, height: 52, backgroundColor: "#B88A45" },
          view: { width: 88, height: 88, backgroundColor: "#B88A45" },
          drag: { width: 88, height: 88, backgroundColor: "#F4EFE7" },
        }}
        transition={{ type: "spring", stiffness: 420, damping: 28 }}
        className="rounded-full -translate-x-1/2 -translate-y-1/2 flex items-center justify-center mix-blend-difference"
      >
        {variant !== "default" && (
          <span className="text-[9px] font-bold tracking-[0.18em] text-black">
            {LABELS[variant]}
          </span>
        )}
      </motion.div>
    </motion.div>
  );
}
